<template>
    <div class="cancel-execution">
        <flex-container justify-content="center">
            <flex-container justify-content="center">
                <icon-clean-up style="max-width: 40%; color: #5756a1" />
            </flex-container>

            <form-validation v-slot="{ bindings }">
                <card-normal class="cancel-execution__card" without-padding>
                    <flex-container :gap="Size.xs" :padding="Size.md">
                        <text-heading>Uitschrijven</text-heading>
                        <flex-container>
                            <input-group v-model="selection" :schema="object({ value: string(). required() })">
                                <template #label>
                                    <input-label>
                                        <slot name="label">
                                            Waarvoor wil je je uitschrijven?
                                        </slot>
                                    </input-label>
                                </template>

                                <template #input>
                                    <text-decorator size="xs">
                                        <radio-group-input
                                            label-key-name="label"
                                            value-key-name="value"
                                            :items="availableSelections"
                                        />
                                    </text-decorator>
                                </template>
                            </input-group>
                        </flex-container>
                    </flex-container>

                    <card-section area="card-footer" :color="'white'">
                        <flex-container justify-content="flex-end">
                            <button-block :disabled="!bindings.isValid.value" @loading="unsubscribe">
                                Uitschrijven
                            </button-block>
                        </flex-container>
                    </card-section>
                </card-normal>
            </form-validation>
        </flex-container>
    </div>
</template>

<script setup lang="ts">
    import {
        ButtonState,
        type ButtonStateChangedEvent,
        CardSection,
        InputGroup,
        InputLabel,
        RadioGroupInput,
        Size,
    } from '@keyvue/one-ui';

    import { CancelExecutionCommand, CancelExecutionsForContactCommand, ContactId } from '@keyvue/one-api-client';

    import { computed, ref } from 'vue';
    import { object, string } from 'yup';
    import useClient from '@/services/keyvue-api/composables/useClient';
    import useNotify from '@/services/keyvue-ui/composables/useNotify';
    import IconCleanUp from '@/flow/execution/assets/undraw_clean_up_re_504g.svg?component';

    enum UnsubscribeType {
        CURRENT = 'current',
        ALL = 'all',
    }

    const props = defineProps<{
        executionId: string,
        contactId: string,
    }>();

    const { client } = useClient();
    const { notifySaved, notifyError } = useNotify();

    const availableSelections = computed(() => {
        return [
            { label: 'Alleen voor deze e-mail', value: UnsubscribeType.CURRENT },
            { label: 'Uitschrijven voor alle e-mails', value: UnsubscribeType.ALL },
        ];
    });
    const selection = ref(availableSelections.value[0]);

    async function unsubscribe(event: ButtonStateChangedEvent) {
        try {
            if (selection.value.value === UnsubscribeType.CURRENT) {
                await client.dispatch(
                    new CancelExecutionCommand(props.executionId),
                );
                notifySaved(undefined, 'Je bent nu uitgeschreven');
                event.button.setState(ButtonState.completed);
            }

            if (selection.value.value === UnsubscribeType.ALL) {
                await client.dispatch(
                    new CancelExecutionsForContactCommand(new ContactId(props.contactId)),
                );
                notifySaved(undefined, 'Je bent nu uitgeschreven');
                event.button.setState(ButtonState.completed);
            }
        } catch (error) {
            // eslint-disable-next-line no-console
            console.error(error);
            notifyError('Er is iets misgegaan bij het uitschrijven');
        } finally {
            event.button.setState(ButtonState.content);
        }
    }
</script>

<style scoped lang="scss">
.cancel-execution {
    display: grid;
    width: 100%;
    height: 100%;
    justify-content: center;
    align-items: center;

    &__card {
        max-width: 35vw
    }
}

@media (max-width: 1024px) {
    .cancel-execution__card {
        max-width: 50vw
    }
}

@media (max-width: 768px) {
    .cancel-execution__card {
        max-width: 70vw
    }
}

@media (max-width: 480px) {
    .cancel-execution__card {
        max-width: 90vw
    }
}
</style>
